import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../../utils/form/application_form_source";
import {getAmplitudeLeadFormInquiryTopics} from "./get_amplitude_lead_form_inquiry_topics";
import {getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit, ILeadSubmitInquirySelection} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

// DS-A-44
export interface IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams extends IGetAmplitudeLeadFormStartEventPropertiesParams {
    leadResponse: IApplicationData;
    inquirySelection: ILeadSubmitInquirySelection;
}

export const getAmplitudeLeadFormGenerateLeadEventProperties = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    const {leadResponse, inquirySelection, trackingContext, leadData, source, sourceSection, eventAction} = params;

    const base = getAmplitudeLeadFormStartEventProperties({
        trackingContext,
        leadData,
        source,
        sourceSection,
        eventAction
    });

    const inquiryTopics = source === ApplicationSource.NegotiatePrice ? [] : getAmplitudeLeadFormInquiryTopics(source);
    const inquiryTopicsSelected = getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit(source, inquirySelection);

    const marketingApproval = Boolean(leadResponse.marketing_email || leadResponse.marketing_sms);

    return {
        ...base,
        transaction_id: leadResponse.uuid,
        inquiry_topics: inquiryTopics,
        inquiry_topics_selected: inquiryTopicsSelected,
        marketing_approval: marketingApproval
    };
};
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../../utils/form/application_form_source";
import {getAmplitudeLeadFormInquiryTopics} from "./get_amplitude_lead_form_inquiry_topics";
import {getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit, ILeadSubmitInquirySelection} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

// DS-A-44
export interface IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams extends IGetAmplitudeLeadFormStartEventPropertiesParams {
    leadResponse: IApplicationData;
    inquirySelection: ILeadSubmitInquirySelection;
}

export const getAmplitudeLeadFormGenerateLeadEventProperties = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    const {leadResponse, inquirySelection, trackingContext, leadData, source, sourceSection, eventAction} = params;

    const base = getAmplitudeLeadFormStartEventProperties({
        trackingContext,
        leadData,
        source,
        sourceSection,
        eventAction
    });

    const inquiryTopics = source === ApplicationSource.NegotiatePrice ? [] : getAmplitudeLeadFormInquiryTopics(source);
    const inquiryTopicsSelected = getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit(source, inquirySelection);

    const marketingApproval = Boolean(leadResponse.marketing_email || leadResponse.marketing_sms);

    return {
        ...base,
        transaction_id: leadResponse.uuid,
        inquiry_topics: inquiryTopics,
        inquiry_topics_selected: inquiryTopicsSelected,
        marketing_approval: marketingApproval
    };
};
